module.exports = "\r\n<app-dashboard></app-dashboard>\r\n"